import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useRefreshTick } from "../lib/useAutoRefresh";
import { Landmark } from "lucide-react";
import { DirectDepositSetup } from "./DirectDepositPanel";

const money = (v) => `$${Number(v || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const HOLD = { cra: "CRA (PD7A)", wsib: "WSIB", eht: "EHT", other: "Third-party" };

// Client portal Overview: funding account, funding mode, funds held by PostWage, last debit — Admin/MGT can set the PAD account.
export function ClientDepositCard({ company, role, onCompanyChange }) {
  const [s, setS] = useState(null);
  const tick = useRefreshTick();
  useEffect(() => { if (company?.company_id) api.get(`/companies/${company.company_id}/payments/summary`).then((r) => setS(r.data)).catch(() => setS(null)); }, [company?.company_id, tick]);
  if (!s) return null;
  const canBank = ["admin", "mgt"].includes(role);
  const full = s.funding_mode === "full_payroll";
  return (
    <div className="mt-8 rounded-2xl bg-white border border-slate-200 p-5 shadow-sm" data-testid="client-deposit-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 text-slate-500 text-sm"><Landmark className="h-4 w-4" /> Direct deposit</div>
          <div className="mt-1 text-sm text-slate-800" data-testid="client-dd-mode">
            <b>{full ? "Full payroll funding" : "Net pay only"}</b>
            <span className="text-slate-500"> — {full ? "PostWage debits net pay plus CRA, WSIB" + (s.eht_rate > 0 ? ", EHT" : "") + " and third-party amounts, and remits them for you." : "PostWage debits only direct-deposit net pay; you remit CRA / WSIB yourself."}</span>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 text-right">
          <div><div className="text-[11px] uppercase tracking-wider text-slate-500">Held by PostWage</div><div className="text-xl font-bold tabular-nums" data-testid="client-dd-held">{money(s.held_total)}</div>
            {s.held_total > 0 && <div className="text-[11px] text-slate-500">{Object.entries(s.held).filter(([, v]) => v > 0).map(([k, v]) => `${HOLD[k]} ${money(v)}`).join(" · ")}</div>}</div>
          <div><div className="text-[11px] uppercase tracking-wider text-slate-500">Last debit</div>
            <div className="text-xl font-bold tabular-nums" data-testid="client-dd-last">{s.last_funding ? money(s.last_funding.amount) : "—"}</div>
            {s.last_funding && <div className="text-[11px] text-slate-500">{String(s.last_funding.at).slice(0, 10)} · {s.last_funding.status}</div>}</div>
        </div>
      </div>
      <div className="mt-4 [&>div]:mb-0 [&>div]:border-0 [&>div]:p-0">
        <DirectDepositSetup company={{ ...company, funding_account: s.funding_account, funding_mode: s.funding_mode, eht_rate: s.eht_rate, pad_agreement: s.pad_agreement }} onCompanyChange={onCompanyChange} canEditBank={canBank} clientView />
      </div>
    </div>
  );
}
